module.exports = __webpack_public_path__ + "static/img/11.1392210.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/benjyfishy/11.png
// module id = bwvl
// module chunks = 35